/**
 * Converts plain text to HTML by escaping HTML characters and converting newlines to br tags.
 * This is useful for converting textarea content to HTML format for email bodies.
 *
 * @param text - The plain text string to convert to HTML
 * @returns The HTML string with escaped characters and newlines converted to br tags
 */
export function textToHtml(text: string): string {
  if (!text) {
    return ''
  }

  // Escape HTML characters
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

  // Convert newlines to br tags
  return escaped.replace(/\r?\n/g, '<br />')
}
